var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessAlertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 186,
    viewBox: "0 0 186 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.33,
    cx: 93,
    cy: 93,
    r: 93,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_540_2252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.7001 98.8095L76.4424 94.1119L86.4389 104.262L87.3199 105.157L87.9946 104.098L109.725 70.0023L115.333 73.5954L88.4577 115.785L71.7001 98.8095Z",
    fill: "#34AD4D",
    stroke: "#FCFCFC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5107 140C67.6282 140 46.5659 118.915 46.5659 93C46.5659 67.0846 67.6068 46 93.5107 46C119.415 46 140.455 67.0846 140.455 93C140.455 118.915 119.393 140 93.5107 140ZM93.5107 50.5188C70.1027 50.5188 51.0772 69.5679 51.0772 93C51.0772 116.432 70.1027 135.481 93.5107 135.481C116.919 135.481 135.944 116.432 135.944 93C135.944 69.5675 116.897 50.5188 93.5107 50.5188Z",
    fill: "#34AD4D",
    stroke: "#FCFCFC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.238 91.9136H19V94.0865H33.238V91.9136Z",
    fill: "#34AD4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2945 61.6798L26.7598 63.2163L36.8276 73.2957L38.3623 71.7592L28.2945 61.6798Z",
    fill: "#34AD4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8432 112.238L26.7754 122.318L28.3101 123.854L38.3779 113.775L36.8432 112.238Z",
    fill: "#34AD4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 91.9136H153.762V94.0865H168V91.9136Z",
    fill: "#34AD4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.705 61.6711L148.638 71.7505L150.172 73.287L160.24 63.2076L158.705 61.6711Z",
    fill: "#34AD4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.167 112.208L148.632 113.744L158.7 123.824L160.234 122.287L150.167 112.208Z",
    fill: "#34AD4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_540_2252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 96,
    fill: "white",
    transform: "translate(19 45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessAlertIcon);
export default __webpack_public_path__ + "static/media/success-alert-icon.1b54569fb0abd9c7078dd9545f54fd77.svg";
export { ForwardRef as ReactComponent };